import React, { Component }  from 'react';
import '../../style.css';
import {Button, Input, message, Modal, PageHeader, Space, Typography} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;
const { TextArea } = Input;

class IPNonReuse extends Component {
    constructor(props) {
        super(props);
        this.state={
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            para1:'',
            para2:'',
            declareTime:'',
            fileStream:'',
            preview_visible:false,
            status:false,
        }
        this.download = this.download.bind(this);
        this.handleExportClick = this.handleExportClick.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getIPNonReuseTemplateB,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            para1:res.data.para1,
                            para2:res.data.para2,
                            declareTime:res.data.declareTime,
                            companyName:res.data.companyName,
                            status:true,
                        }))
                    }
                }
            )
    }
    handleExportClick(){
        let params = {
            companyId:this.state.companyId,
        }
        fetchPost(global.constants.exportTemplateB,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-2知识产权未重复使用声明.doc',
            fileName: '知识产权未重复使用声明.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-2知识产权未重复使用声明.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-2知识产权未重复使用声明.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/知识产权未重复使用声明.pdf',
                            fileName: '知识产权未重复使用声明.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    edit(){
        this.setState(()=>({
            status:false,
        }))
    }
    submit(){
        let params={
            companyId:this.state.companyId,
            companyName:this.state.companyName,
            para1:this.state.para1,
            para2:this.state.para2,
            declareTime: this.state.declareTime,
        }
        fetchPost(global.constants.updateIPNonReuseTemplateB, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        message.success("添加成功！").then()
                        fetchPost(global.constants.getIPNonReuseTemplateB,{companyId: this.state.companyId})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            para1:res.data.para1,
                                            para2:res.data.para2,
                                            declareTime:res.data.declareTime,
                                            companyName:res.data.companyName,
                                            status:true,
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return(
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
            <div className="content-page-header">
                <PageHeader
                    ghost={false}
                    title="知识产权未重复使用说明"
                    extra={[
                        <Button
                            onClick={this.handleExportClick.bind(this)}>生成</Button>,
                        <Button
                            type="primary"
                            onClick={this.handlePreviewClick.bind(this)}
                        >预览</Button>,
                    ]}
                >
                </PageHeader>
            </div>
            <div className="content-frame-wordStyle">
                <div className="content-form-wordStyle">
                <Space direction="vertical" style={{width:'94%',padding:'3%'}}>
                    <div className = "word">
                        <span className="word-title">
                            知识产权未重复使用声明
                        </span>
                    </div>
                    <Typography>
                        {
                            this.state.para1 !== '' &&
                            <Paragraph className="textStyle">
                                {
                                    this.state.status === false?
                                        <TextArea
                                            value={this.state.para1}
                                            onChange={this.para1Change.bind(this)}
                                            autoSize={{ minRows: 2, maxRows: 6 }}
                                        />
                                        :
                                        this.state.para1
                                }
                            </Paragraph>
                        }
                        {
                            this.state.para2 !== '' &&
                            <Paragraph className="textStyle">
                                {
                                    this.state.status === false?
                                        <TextArea
                                            value={this.state.para2}
                                            onChange={this.para2Change.bind(this)}
                                            autoSize={{ minRows: 2, maxRows: 6 }}
                                        />:
                                        this.state.para2
                                }
                            </Paragraph>
                        }
                        {
                            (this.state.para1 === '' && this.state.para2 === '') &&
                               <Paragraph>
                                   <Paragraph className="textStyle">
                                       {
                                           this.state.status === false?
                                               <TextArea
                                                   placeholder={'请输入二类知识产权未重复使用说明'}
                                                   value={this.state.para1}
                                                   onChange={this.para1Change.bind(this)}
                                                   autoSize={{ minRows: 2, maxRows: 6 }}
                                               />
                                               :
                                               this.state.para1
                                       }
                                   </Paragraph>
                                   <Paragraph className="textStyle">
                                       {
                                           this.state.status === false?
                                               <TextArea
                                                   placeholder={'请输入一类知识产权未重复使用说明'}
                                                   value={this.state.para2}
                                                   onChange={this.para2Change.bind(this)}
                                                   autoSize={{ minRows: 2, maxRows: 6 }}
                                               />:
                                               this.state.para2
                                       }
                                   </Paragraph>
                               </Paragraph>
                        }
                        <Paragraph className="textStyle">
                            特此声明。
                        </Paragraph>
                        <div style={{float:'right'}}>
                            <Paragraph className="textStyle">
                                企业名称（公章）：{this.state.companyName}
                            </Paragraph>
                            <Paragraph className="textStyle">
                                {
                                    this.state.status === false?
                                        <Input
                                            style={{width:'200px'}}
                                            placeholder={'请填写文件时间'}
                                            defaultValue={this.state.declareTime}
                                            onChange={this.declareTimeChange.bind(this)}
                                        />:
                                        this.state.declareTime
                                }
                            </Paragraph>
                        </div>
                    </Typography>
                    <div>
                        <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                        <Button
                            disabled={!this.state.status}
                            type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                    </div>
                </Space>
                    <Modal
                        visible={this.state.preview_visible}
                        title={'预览'}
                        onCancel={this.hideModal}
                        destroyOnClose
                        width={'50%'}
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                                下载
                            </Button>,
                        ]}
                    >
                        <FileViewer fileType='pdf'
                                    filePath={this.state.fileStream}
                                    onError={this.onError}
                        />
                    </Modal>
                </div>
            </div>
        </div>
        )
    }
    para1Change(e){
        const value = e.target.value
        this.setState(()=>({
            para1:value
        }))
    }
    para2Change(e) {
        const value = e.target.value;
        this.setState(() => ({
            para2: value
        }))
    }
    declareTimeChange(e){
        const value = e.target.value
        this.setState(()=>({
            declareTime:value
        }))
    }
}
export default IPNonReuse;